// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-heading-horizon[data-v-f9adc803]{padding:2.135vw}", ""]);
// Exports
module.exports = exports;
